import Loader from 'react-ts-loaders';
import React from 'react';
import css from './download-private-pdf-button.module.scss';
import { PrivateTemplateEditor } from '@start-set/wakadoo-editor-core';
import { IPrivateTemplateData } from '../../../../../../../entities/template/types';
import { DownloadButton } from '../../../../../../../shared/ui/buttons/download-pdf/download-pdf';

interface IDownloadPDFButtonProps {
	onDownloadPDF: (
		editor: PrivateTemplateEditor | null,
		template: IPrivateTemplateData,
	) => void;
	isPDFAvailable: boolean;
	isPDFLoading?: boolean;
	editor: PrivateTemplateEditor | null;
	template: IPrivateTemplateData;
}

export const DownloadPrivatePdfButton = ({
	onDownloadPDF,
	isPDFAvailable,
	isPDFLoading,
	editor,
	template,
}: IDownloadPDFButtonProps) => {
	return (
		<DownloadButton
			onClick={() => onDownloadPDF(editor, template)}
			disabled={!isPDFAvailable || isPDFLoading}
			showIcon={false}
		>
			{isPDFLoading ? (
				<div className={css.buttonContent}>
					Скачать PDF
					<Loader className={css.pdfLoader} type="ring" color="#d8d7d7" size={18} />
				</div>
			) : (
				'Скачать PDF'
			)}
		</DownloadButton>
	);
};
